const config = {
  nodeEnv: 'dev',
  assetPath: '/template/assets',
  assetPathAbsolute: 'https://qa.new.northwesternmutual.com/template/assets',
  port: { browserSync: '7022' },
  public: {
    googleAnalyticsTrackingId: 'UA-37147409-30',
    googlePlacesApiKey: 'AIzaSyDoQaSl4iGvxiUrd4qNm2AzJob3SPNpkeI',
    recaptchaInvisible: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaInvisibleComment: 'used for testing purposes',
    recaptchaV3: '6LdvCMAZAAAAAGWm_QcQ9adKCatLTxNIDRppX9G_',
    tealiumAgentIdProperty: '6143',
  },
};

module.exports = config;
